// extracted by mini-css-extract-plugin
export default {"link":"TZkUX1Id5f6zMAckYZ_L","placeHolderShimmer":"Fzb0wtxBEBHz1vQr9LOI"};